import { createSlice } from "@reduxjs/toolkit";
import { HandoffOffer } from "../chat/types";
import { updateHandoff } from "../actions/sharedActions";

interface HandoffExtraData {
  firstName: string;
  lastName: string;
}

export interface HandoffState {
  data: Record<string, HandoffOffer>;
  extraData: Record<string, HandoffExtraData | undefined>;
  status: Record<string, "idle" | "loading" | "succeeded" | "failed">;
  error: Record<
    string,
    {
      status: number;
      headers: Record<string, string>;
      body: any;
    } | null
  >;
}

export const extraDataInitialState: HandoffExtraData = {
  firstName: "",
  lastName: "",
};

const initialState: HandoffState = {
  data: {},
  extraData: {},
  status: {},
  error: {},
};

const handoffSlice = createSlice({
  name: "handoff",
  initialState,
  reducers: {
    setHandoff: (state, action: { payload: { handoff: HandoffOffer } }) => {
      const { handoff } = action.payload;
      state.data[handoff.id] = handoff;
      state.status[handoff.id] = "succeeded";
      state.error[handoff.id] = null;
    },
    setHandoffExtra: (
      state,
      action: {
        payload: { handoffId: string; firstName: string; lastName: string };
      }
    ) => {
      const { handoffId, firstName, lastName } = action.payload;
      state.extraData[handoffId] = { firstName, lastName };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateHandoff.pending, (state, action) => {
        const { handoff } = action.meta.arg;
        state.status[handoff.id] = "loading";
        state.error[handoff.id] = null;
      })
      .addCase(updateHandoff.fulfilled, (state, action) => {
        // NOTE(liamvdv): self-sync
        const { handoff } = action.meta.arg;
        state.data[handoff.id] = handoff;
        state.status[handoff.id] = "succeeded";
        state.error[handoff.id] = null;
      })
      .addCase(updateHandoff.rejected, (state, action) => {
        const { handoff } = action.meta.arg;
        state.status[handoff.id] = "failed";
        state.error[handoff.id] = action.payload.error;
      });
  },
});

export const { setHandoff, setHandoffExtra } = handoffSlice.actions;

export const handoffReducer = handoffSlice.reducer;
